"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVolumeStrategyValue = exports.getPriceSummaryTotalForItem = exports.collectDiscounts = exports.getPriceSummaryForItem = exports.getQuoteSummaryForItem = void 0;
function getQuoteSummaryForItem(quoteSummary, type, id) {
    var e_1, _a, e_2, _b, e_3, _c;
    if (type === "page")
        return quoteSummary;
    try {
        for (var _d = __values(quoteSummary.blocks), _e = _d.next(); !_e.done; _e = _d.next()) {
            var block = _e.value;
            if (type === "block" && block.id === id)
                return block;
            try {
                for (var _f = (e_2 = void 0, __values(block.sections)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var section = _g.value;
                    if (type === "section" && section.id === id)
                        return section;
                    try {
                        for (var _h = (e_3 = void 0, __values(section.lineItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var lineItem = _j.value;
                            if (type === "lineItem" && lineItem.id === id)
                                return lineItem;
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    throw new Error("Couldn't find ".concat(type, " with id ").concat(id, " in quoteSummary"));
}
exports.getQuoteSummaryForItem = getQuoteSummaryForItem;
function getPriceSummaryForItem(priceSummary, type, id) {
    var e_4, _a, e_5, _b, e_6, _c;
    if (type === "page")
        return priceSummary;
    try {
        for (var _d = __values(priceSummary.blocks), _e = _d.next(); !_e.done; _e = _d.next()) {
            var block = _e.value;
            if (type === "block" && block.id === id)
                return block;
            try {
                for (var _f = (e_5 = void 0, __values(block.sections)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var section = _g.value;
                    if (type === "section" && section.id === id)
                        return section;
                    try {
                        for (var _h = (e_6 = void 0, __values(section.lineItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var lineItem = _j.value;
                            if (type === "lineItem" && lineItem.id === id)
                                return lineItem;
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_4) throw e_4.error; }
    }
    throw new Error("Couldn't find ".concat(type, " with id ").concat(id, " in priceSummary"));
}
exports.getPriceSummaryForItem = getPriceSummaryForItem;
var mergeDiscounts = function (self, children) {
    var e_7, _a, e_8, _b;
    var _c, _d;
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            var childFrequencies = Object.keys(child);
            try {
                for (var childFrequencies_1 = (e_8 = void 0, __values(childFrequencies)), childFrequencies_1_1 = childFrequencies_1.next(); !childFrequencies_1_1.done; childFrequencies_1_1 = childFrequencies_1.next()) {
                    var childFrequency = childFrequencies_1_1.value;
                    self[childFrequency] = __spreadArray(__spreadArray([], __read(((_c = self[childFrequency]) !== null && _c !== void 0 ? _c : [])), false), __read(((_d = child[childFrequency]) !== null && _d !== void 0 ? _d : [])), false);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (childFrequencies_1_1 && !childFrequencies_1_1.done && (_b = childFrequencies_1.return)) _b.call(childFrequencies_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return self;
};
function collectDiscounts(priceSummary) {
    var e_9, _a;
    var _b, _c;
    var selfDiscounts = {};
    var frequencies = Object.keys(priceSummary.total);
    try {
        for (var frequencies_1 = __values(frequencies), frequencies_1_1 = frequencies_1.next(); !frequencies_1_1.done; frequencies_1_1 = frequencies_1.next()) {
            var frequency = frequencies_1_1.value;
            selfDiscounts[frequency] = ((_c = (_b = priceSummary.total[frequency]) === null || _b === void 0 ? void 0 : _b.discounts) !== null && _c !== void 0 ? _c : [])
                .filter(function (discount) { return discount.target === "self"; })
                .map(function (discount) {
                var level = "blocks" in priceSummary
                    ? "page"
                    : "sections" in priceSummary
                        ? "block"
                        : "lineItems" in priceSummary
                            ? "section"
                            : "lineItem";
                return __assign(__assign({}, discount), { level: level });
            });
        }
    }
    catch (e_9_1) { e_9 = { error: e_9_1 }; }
    finally {
        try {
            if (frequencies_1_1 && !frequencies_1_1.done && (_a = frequencies_1.return)) _a.call(frequencies_1);
        }
        finally { if (e_9) throw e_9.error; }
    }
    if ("blocks" in priceSummary) {
        return mergeDiscounts(selfDiscounts, priceSummary.blocks.map(collectDiscounts));
    }
    else if ("sections" in priceSummary) {
        return mergeDiscounts(selfDiscounts, priceSummary.sections.map(collectDiscounts));
    }
    else if ("lineItems" in priceSummary) {
        return mergeDiscounts(selfDiscounts, priceSummary.lineItems.map(collectDiscounts));
    }
    else {
        return selfDiscounts;
    }
}
exports.collectDiscounts = collectDiscounts;
var getPriceSummaryTotalForItem = function (priceSummary, id) {
    var e_10, _a, e_11, _b, e_12, _c;
    if (!id)
        return priceSummary.total;
    try {
        for (var _d = __values(priceSummary.blocks), _e = _d.next(); !_e.done; _e = _d.next()) {
            var block = _e.value;
            if (id === block.id)
                return block.total;
            try {
                for (var _f = (e_11 = void 0, __values(block.sections)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var section = _g.value;
                    if (id === section.id)
                        return section.total;
                    try {
                        for (var _h = (e_12 = void 0, __values(section.lineItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var lineItem = _j.value;
                            if (id === lineItem.id)
                                return lineItem.total;
                        }
                    }
                    catch (e_12_1) { e_12 = { error: e_12_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_12) throw e_12.error; }
                    }
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
    }
    catch (e_10_1) { e_10 = { error: e_10_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_10) throw e_10.error; }
    }
    return {};
};
exports.getPriceSummaryTotalForItem = getPriceSummaryTotalForItem;
var getVolumeStrategyValue = function (field, amount) {
    var e_13, _a;
    var result = field.baseValue;
    try {
        for (var _b = __values(field.tiers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var tier = _c.value;
            if (amount >= tier.minimumThreshold) {
                result = tier.value;
            }
        }
    }
    catch (e_13_1) { e_13 = { error: e_13_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_13) throw e_13.error; }
    }
    return result;
};
exports.getVolumeStrategyValue = getVolumeStrategyValue;
